import { useMemo } from 'react';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

// project imports
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import IconButton from 'components/@extended/IconButton';

import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { MenuOrientation, DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// assets
import MenuOpenIcon from '@mui/icons-material/MenuOpen'; // Replaces MenuFoldOutlined
import MenuIcon from '@mui/icons-material/Menu'; // Replaces MenuUnfoldOutlined
import MenuOpenOutlinedIcon from '@mui/icons-material/MenuOpenOutlined';

import { Box } from '@mui/material';
import { getDashboardData } from '../../../helper/getDashboardData';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { menuOrientation } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const dashboardData = useMemo(() => getDashboardData(), []);
  const fullName = dashboardData?.userProfile?.firstName + ' ' + dashboardData?.userProfile?.lastName;

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // common header
  const mainHeader = (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: {xs: 'flex-start', sm: 'center'}, gap: 1, flexDirection: { xs: 'column', sm: 'row' }, }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {!isHorizontal ? (
          <IconButton
            aria-label="open drawer"
            onClick={() => handlerDrawerOpen(!drawerOpen)}
            edge="start"
            color="secondary"
            variant="light"
            sx={(theme) => ({
              color: 'text.primary',
              bgcolor: drawerOpen ? 'transparent' : 'grey.100',
              ...theme.applyStyles('dark', { bgcolor: drawerOpen ? 'transparent' : 'background.default' }),
              ml: { xs: 0, lg: -2 },
              mr: 1
            })}
          >
            {!drawerOpen ? <MenuOpenOutlinedIcon style={{transform: 'rotateY(180deg)'}} /> : <MenuOpenOutlinedIcon />}
          </IconButton>
        ) : null}
        <span style={{ fontFamily: 'sans-serif' }}>
          <b>Hello</b>,{' '}
          <span
            style={{
              display: 'inline-block', // Crucial: allows width and ellipsis to work
              maxWidth: '200px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',    // Crucial: forces text onto a single line
              verticalAlign: 'bottom'  // Optional: keeps text aligned with "Hello"
            }}
          >
            {fullName}
          </span>
          ! 🙏
        </span>

      </Box>
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      zIndex: 1200,
      width: isHorizontal
        ? '100%'
        : { xs: '100%', lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` }
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
